module.exports = __webpack_public_path__ + "static/media/fly0032.60926b2b.webp";